import { ReactNode, useCallback } from "react";

import { StaleCallConfirmDialog } from "@/components/notifications/stale-call-confirm-dialog";
import { NotificationStateContextType, useNotificationHandler } from "@/hooks/notifications/use-notification-handler";
import { useCall } from "@/providers/hooks/use-call";

import { createNotificationProvider } from "./notification-provider";

export const { Provider: NotificationProvider, useNotification } =
    createNotificationProvider<NotificationStateContextType>();

// Notification center provider that wraps the base notification provider with state management
export const NotificationProviderWrapper = ({ children }: { children: ReactNode }) => {
    const { notificationHandler, pendingStaleCall, confirmStaleCall, dismissStaleCall, ...notificationStates } =
        useNotificationHandler();
    const { initialize } = useCall();

    const handleInit = useCallback(
        (fcmToken: string) => {
            initialize(fcmToken);
        },
        [initialize]
    );

    return (
        <NotificationProvider
            notificationHandler={notificationHandler}
            onInit={handleInit}
            notificationStates={{
                ...notificationStates,
                pendingStaleCall,
                confirmStaleCall,
                dismissStaleCall,
            }}
        >
            <StaleCallConfirmDialog
                open={!!pendingStaleCall}
                onOpenChange={(open) => {
                    if (!open) dismissStaleCall();
                }}
                call={pendingStaleCall}
                onConfirm={confirmStaleCall}
                onCancel={dismissStaleCall}
            />
            {children}
        </NotificationProvider>
    );
};
